/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/general/youtube-api-manager.js":
/*!****************************************************!*\
  !*** ./zrc/scripts/general/youtube-api-manager.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ YouTubeAPIManager)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);

class YouTubeAPIManager {
  constructor(container, videosContainer) {
    this.container = container;
    this.videosContainer = videosContainer || 'div.iframe-youtube';
    this.youtubeVideos = [];
  }
  isYouTubeAPILoaded() {
    return typeof YT !== 'undefined' && window.YT.Player;
  }
  waitForYouTubeAPI() {
    // eslint-disable-next-line consistent-return
    return new Promise(resolve => {
      if (this.isYouTubeAPILoaded()) {
        return resolve();
      }
      var checkInterval = window.setInterval(() => {
        if (this.isYouTubeAPILoaded() === false) {
          return;
        }
        window.clearInterval(checkInterval);
        resolve();
      }, 100);
    });
  }
  loadYouTubeAPI() {
    var _this = this;
    return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      if (_this.isYouTubeAPILoaded()) {
        _this.initYouTubePlayers();
        return;
      }
      yield new Promise((resolve, reject) => {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = resolve;
        tag.onerror = err => reject(new Error("Error loading YouTube API: ".concat(err)));
      });
      yield _this.waitForYouTubeAPI();
      _this.initYouTubePlayers();
    })();
  }
  initYouTubePlayers() {
    this.youtubeVideos = this.container.querySelectorAll(this.videosContainer);
    if (this.youtubeVideos == null) {
      return;
    }
    if (this.youtubeVideos.length < 1) {
      return;
    }
    this.youtubeVideos.forEach(video => {
      var videoId = video.dataset.mediaId;
      var parentEl = video.parentNode;
      var player = new window.YT.Player(video, {
        videoId,
        playerVars: {
          loop: 1,
          origin: window.location.origin
        }
      });
      parentEl.querySelector('iframe').player = player;
    });
  }
}

/***/ }),

/***/ "./zrc/scripts/templates/product-alternate/main/product-carousel-modal.js":
/*!********************************************************************************!*\
  !*** ./zrc/scripts/templates/product-alternate/main/product-carousel-modal.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper/js/swiper.esm */ "./node_modules/swiper/js/swiper.esm.js");
/* harmony import */ var _general_youtube_api_manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../general/youtube-api-manager */ "./zrc/scripts/general/youtube-api-manager.js");


class productCarouselModal extends window.HTMLElement {
  connectedCallback() {
    this.container = this;
    this.slider = undefined;
    this.sliderEl = this.querySelector('.product-carousel-modal-container');
    this.closeButtonEl = this.querySelector('.product-carousel-modal-icon-close');
    this.hiddenClass = 'hidden';
    this.isClosed = true;
    this.youTubeManager = new _general_youtube_api_manager__WEBPACK_IMPORTED_MODULE_0__.default(this);
    this.initSlider();
    this.attachListeners();
  }
  attachListeners() {
    this.closeButtonEl.addEventListener('click', this.close.bind(this));
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') {
        return;
      }
      this.close();
    });
  }
  initSlider() {
    var slidesLength = parseInt(this.sliderEl.dataset.slides, 10);
    var paginationEl = this.querySelector('.swiper-pagination');
    var buttonNextEl = this.querySelector('.swiper-button-next');
    var buttonPrevEl = this.querySelector('.swiper-button-prev');
    swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_1__.Swiper.use([swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_1__.Pagination, swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_1__.Navigation]);
    this.slider = new swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_1__.Swiper(this.sliderEl, {
      longSwipesRatio: 0,
      loop: slidesLength > 1,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: buttonNextEl,
        prevEl: buttonPrevEl
      },
      pagination: slidesLength <= 1 ? false : {
        el: paginationEl,
        type: 'bullets',
        clickable: true
      },
      resistanceRatio: 0,
      slidesPerView: 'auto',
      watchOverflow: true,
      watchSlidesProgress: true,
      breakpoints: {
        0: {
          spaceBetween: 25
        },
        791: {
          spaceBetween: 0
        }
      }
    });
    this.youTubeManager.loadYouTubeAPI().then(() => {
      this.slider.on('slideChangeTransitionEnd', () => {
        this.playCurrentSlideVideo();
      });
      this.slider.on('slideChangeTransitionStart', () => {
        this.pauseAllVideos();
      });
    }).catch(err => {
      window.console.log(err);
    });
  }
  playCurrentSlideVideo() {
    var activeIndex = this.slider.activeIndex;
    var activeSlide = this.slider.slides[activeIndex];

    // this.pauseAllVideos();

    window.console.log(this.slider, {
      activeIndex,
      activeSlide
    });
    // Handle the current (new) slide's video (if exists)
    if (activeSlide) {
      var currentVideo = activeSlide.querySelector('.product-carousel-modal-video');
      this.playVideo(currentVideo);
    }
  }
  open() {
    var _mediaElement$dataset;
    var mediaElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var index = 1;
    if ((mediaElement === null || mediaElement === void 0 || (_mediaElement$dataset = mediaElement.dataset) === null || _mediaElement$dataset === void 0 ? void 0 : _mediaElement$dataset.swiperSlideIndex) != null) {
      index = parseInt(mediaElement.dataset.swiperSlideIndex, 10);
    }
    this.slider.slideToLoop(0, 0, false);
    this.slider.slideToLoop(index, 0, false);
    this.classList.remove(this.hiddenClass);
    this.isClosed = false;
    this.playCurrentSlideVideo();
  }
  close() {
    this.classList.add(this.hiddenClass);
    this.isClosed = true;
    this.pauseAllVideos();
  }
  pauseVideo(videoEl) {
    if (videoEl == null) {
      return;
    }
    if (videoEl.tagName.toLowerCase() === 'iframe') {
      var _videoEl$player;
      videoEl === null || videoEl === void 0 || (_videoEl$player = videoEl.player) === null || _videoEl$player === void 0 || _videoEl$player.pauseVideo();
      return;
    }
    videoEl.pause();
    videoEl.currentTime = 0;
  }
  playVideo(videoEl) {
    if (videoEl == null) {
      return;
    }
    if (videoEl.tagName.toLowerCase() === 'iframe') {
      var _videoEl$player2;
      videoEl === null || videoEl === void 0 || (_videoEl$player2 = videoEl.player) === null || _videoEl$player2 === void 0 || _videoEl$player2.playVideo();
      return;
    }
    videoEl.play();
  }
  pauseAllVideos() {
    var videos = this.querySelectorAll('.product-carousel-modal-video');
    videos.forEach(video => {
      this.pauseVideo(video);
    });
  }
}
if (window.customElements.get('product-carousel-modal') == null) {
  window.customElements.define('product-carousel-modal', productCarouselModal);
}

/***/ }),

/***/ "./zrc/scripts/templates/product-alternate/main/product-linking.js":
/*!*************************************************************************!*\
  !*** ./zrc/scripts/templates/product-alternate/main/product-linking.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);

/* eslint-disable id-length */
/* eslint-disable radix */

var nameCustomElement = "product-linking";
class ProductLinking extends window.HTMLElement {
  connectedCallback() {
    this.jsonContainerSibilings = this.querySelector("#prodict_linking_sibilings");
    this.products = JSON.parse(this.jsonContainerSibilings.innerHTML.trim());
    this.viewAllButtonEl = this.querySelector('.product-linking-options-discover-button');
    this.productOptionsArray = this.querySelectorAll(".product-linking-option-input");
    this.titleEl = this.querySelector(".product-linking-name");
    this.optionsGridEl = this.querySelector(".product-linking-options-list-wrapper");
    this.isExpanded = false;
    this.userClickExpand = false;

    // Si no hay productos "hermanos" entonces ya no hacemos nada
    if (this.products.length < 1) {
      return;
    }
    this.initProductLinkingOptions();
    this.checkContentHeight();
  }
  attachListeners() {
    this.viewAllButtonEl.addEventListener('click', () => {
      this.classList.remove('scrollable');
      this.isExpanded = true;
      this.userClickExpand = true;
    });

    // funcion para agregar los escuchas a las opciones de PL y saber cuando se ah cambiado de producto
    this.productOptionsArray.forEach(productOption => {
      productOption.addEventListener("change", () => {
        if (productOption.checked === false) {
          return;
        }
        this.onProductLinkingOptionClicked(productOption.value);
      });
    });
    window.addEventListener('resize', () => {
      this.checkContentHeight();
    });
  }
  initProductLinkingOptions() {
    // mandamos a llamar el contenido de todos los productos hermanos.
    this.getProductsContentPromise(this.products).then(productsContent => {
      // Aqui ya tenemos el contenido de los productos

      // ponemos el contenido dentro del arreglo de los productos filtrados
      productsContent.forEach((productContent, index) => {
        this.products[index].content = productContent;
      });
      this.attachListeners();
      this.classList.remove("disabled");
    }).catch(error => {
      window.console.log(error);
    });
  }
  getProductsContentPromise(products) {
    return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()(function* () {
      try {
        var urls = [];
        products.forEach(product => {
          urls.push(product.product_url);
        });

        // Realizar las llamadas Fetch y obtener un array de promesas
        var promisesFetch = urls.map(url => window.fetch(url));

        // Esperar a que se resuelvan todas las promesas
        var responses = yield Promise.all(promisesFetch);

        // Obtener los resultados de todas las respuestas, y se obtienen por página
        var results = yield Promise.all(responses.map(response => response.text()));
        results.forEach((result, index) => {
          results[index] = new window.DOMParser().parseFromString(result, "text/html");
        });
        return results;
      } catch (error) {
        // Manejo de errores
        window.console.error(error);
        return [];
      }
    })();
  }
  onProductLinkingOptionClicked(inputValue) {
    // window.console.log(inputValue);
    // funcion para realizar las acciones al momento de cambiar de producto.

    // obtenemos el producto seleccionado para empezar a remplazar todas las partes necesarias de la page
    var productID = parseInt(inputValue, 10);
    var productSelected = this.products.find(product => {
      if (productID === product.id) {
        return product;
      }
      return false;
    });

    // update url
    window.history.replaceState({}, "", productSelected.product_url);

    // update title tab
    document.title = productSelected.title;

    // obtenemos todos los elementos con el attributo espacial para actualizar y tambien el orden
    this.updateElements(productSelected).then(() => {
      this.titleEl.innerHTML = productSelected.title;
      // Set Event of change product linking option
      document.dispatchEvent(new window.Event("update::product_linking"));
    }).catch(error => {
      window.console.log(error);
    });
  }
  updateElements(productSelected) {
    return new Promise(resolve => {
      var elementsUpdateNames = [];
      var $elementsToUpdate = Array.from(document.querySelectorAll("[data-product-linking-update]"));
      var $elementsToUpdateWithOrder = $elementsToUpdate.filter(item => item.hasAttribute("data-update-order"));
      var $elementsToUpdateWithoutOrder = $elementsToUpdate.filter(item => !item.hasAttribute("data-update-order"));
      $elementsToUpdateWithOrder.sort((a, b) => parseInt(a.getAttribute("data-update-order")) - parseInt(b.getAttribute("data-update-order")));
      var $finalElementsOrderToUpdate = [...$elementsToUpdateWithoutOrder, ...$elementsToUpdateWithOrder];
      $finalElementsOrderToUpdate.forEach($element => {
        var $elementName = $element.dataset.productLinkingUpdate;
        var $newElement = productSelected.content.querySelector("[data-product-linking-update=\"".concat($elementName, "\"]"));
        if ($newElement == null) {
          $element.classList.add("hidden");
          return;
        }
        elementsUpdateNames.push($elementName);
        $element.replaceWith($newElement.cloneNode(true));
      });
      resolve(elementsUpdateNames);
    });
  }
  checkContentHeight() {
    // if (this.isExpanded) { return; }
    if (this.userClickExpand) {
      return;
    }
    var optionEl = this.querySelector(".product-linking-option:first-child");
    var oneRowHeight = optionEl.clientHeight;
    this.classList.remove('scrollable');
    this.isExpanded = true;
    var contentHeight = this.optionsGridEl.clientHeight;
    if (contentHeight > oneRowHeight) {
      this.classList.add('scrollable');
      this.isExpanded = false;
    }
  }
}
if (!window.customElements.get(nameCustomElement)) {
  window.customElements.define(nameCustomElement, ProductLinking);
}

/***/ }),

/***/ "./zrc/scripts/templates/product-alternate/main/product-main.js":
/*!**********************************************************************!*\
  !*** ./zrc/scripts/templates/product-alternate/main/product-main.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! swiper/js/swiper.esm */ "./node_modules/swiper/js/swiper.esm.js");
/* harmony import */ var _general_youtube_api_manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../general/youtube-api-manager */ "./zrc/scripts/general/youtube-api-manager.js");
/* harmony import */ var _product_carousel_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./product-carousel-modal */ "./zrc/scripts/templates/product-alternate/main/product-carousel-modal.js");
/* harmony import */ var _size_guide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./size-guide */ "./zrc/scripts/templates/product-alternate/main/size-guide.js");
/* harmony import */ var _size_guide__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_size_guide__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _product_linking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./product-linking */ "./zrc/scripts/templates/product-alternate/main/product-linking.js");
/* eslint-disable no-undef */





class Product extends window.HTMLElement {
  connectedCallback() {
    this.init();
    document.addEventListener('update::product_linking', () => {
      this.init();
      if (window.Rebuy != null && window.Rebuy.reinit != null) {
        var _window, _window2, _window3;
        (_window = window) === null || _window === void 0 || (_window = _window.Rebuy) === null || _window === void 0 || _window.reinit();
        (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Rebuy) === null || _window2 === void 0 || (_window2 = _window2.SmartCart) === null || _window2 === void 0 || _window2.unbindEvents();
        (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.Rebuy) === null || _window3 === void 0 || (_window3 = _window3.SmartCart) === null || _window3 === void 0 || _window3.bindEvents();
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }
  init() {
    this.container = this;
    this.mediaElements = this.querySelectorAll('.product-carousel-container .product-carousel-image-container, .product-carousel-container .product-carousel-video-container');
    this.sliderModal = this.querySelector('product-carousel-modal');
    this.tabsElements = this.querySelectorAll('.product-tab-container .product-tab');
    this.youTubeManager = new _general_youtube_api_manager__WEBPACK_IMPORTED_MODULE_0__.default(this, '.product-carousel-container div.iframe-youtube');
    this.mediaMobileChange = 834;
    this.slider = null;
    this.carousel();
    this.checkHeaderHeight();
    this.swatches();
    this.quantitySelector();
    this.preorderButton();
    this.attachListeners();
  }
  attachListeners() {
    window.addEventListener('resize', () => {
      this.carousel();
    });
    this.mediaElements.forEach(mediaElement => {
      mediaElement.addEventListener('click', () => {
        this.onMediaClick(mediaElement);
      });
    });
    this.tabsElements.forEach(tab => {
      tab.addEventListener('click', () => {
        this.openTab(tab);
      });
    });
  }
  carousel() {
    if (window.matchMedia("(min-width: ".concat(this.mediaMobileChange, "px)")).matches) {
      if (this.slider == null) {
        return;
      }
      this.slider.destroy(true);
      this.slider = null;
      return;
    }
    if (this.slider != null) {
      return;
    }
    var sliderEl = this.querySelector('.product-carousel-container');
    var paginationEl = this.querySelector('.product-carousel-pagination');
    var slidesLength = parseInt(sliderEl.dataset.slides, 10);
    swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_4__.Swiper.use([swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_4__.Pagination]);
    this.slider = new swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_4__.Swiper(sliderEl, {
      longSwipesRatio: 0,
      loop: slidesLength > 1,
      observer: true,
      observeParents: true,
      pagination: slidesLength <= 1 ? false : {
        el: paginationEl,
        type: 'bullets',
        clickable: true
      },
      resistanceRatio: 0,
      slidesPerView: 'auto',
      watchOverflow: true,
      breakpoints: {
        0: {
          spaceBetween: 25
        },
        791: {
          spaceBetween: 0
        }
      }
    });

    // eslint-disable-next-line shopify/prefer-early-return
    $(this.container).on('variantChange', event => {
      if (event.variant.featured_media !== undefined) {
        var currentVariantMediaId = event.variant.featured_media.id;
        var variantSlide = $('.product-carousel-container').find(".swiper-slide[data-media-id=\"".concat(currentVariantMediaId, "\"]:not(.swiper-slide-duplicate)"));
        if (variantSlide.length > 0) {
          var swiperIndex = parseInt($(variantSlide[0]).attr('data-swiper-slide-index'), 10);
          this.slider.slideToLoop(swiperIndex);
        }
      }
    });
    this.youTubeManager.loadYouTubeAPI().then(() => {
      this.slider.on('slideChangeTransitionEnd', () => {
        var activeIndex = this.slider.activeIndex;
        var activeSlide = this.slider.slides[activeIndex];
        this.pauseAllVideos();

        // Handle the current (new) slide's video (if exists)
        if (activeSlide) {
          var currentVideo = activeSlide.querySelector('.product-carousel-video');
          this.playVideo(currentVideo);
        }
      });
    }).catch(err => {
      window.console.log(err);
    });
  }
  pauseVideo(videoEl) {
    if (videoEl == null) {
      return;
    }
    if (videoEl.tagName.toLowerCase() === 'iframe') {
      var _videoEl$player;
      videoEl === null || videoEl === void 0 || (_videoEl$player = videoEl.player) === null || _videoEl$player === void 0 || _videoEl$player.pauseVideo();
      return;
    }
    videoEl.pause();
    videoEl.currentTime = 0;
  }
  playVideo(videoEl) {
    if (videoEl == null) {
      return;
    }
    if (videoEl.tagName.toLowerCase() === 'iframe') {
      var _videoEl$player2, _videoEl$player3;
      videoEl === null || videoEl === void 0 || (_videoEl$player2 = videoEl.player) === null || _videoEl$player2 === void 0 || _videoEl$player2.mute();
      videoEl === null || videoEl === void 0 || (_videoEl$player3 = videoEl.player) === null || _videoEl$player3 === void 0 || _videoEl$player3.playVideo();
      return;
    }
    videoEl.play();
  }
  pauseAllVideos() {
    var videos = this.querySelectorAll('.product-carousel-container .product-carousel-video');
    videos.forEach(video => {
      this.pauseVideo(video);
    });
  }
  checkHeaderHeight() {
    function getHeight() {
      var headerHeight = document.querySelector('.header-section-wrapper').offsetHeight;
      var carouselSection = document.querySelector('.product-carousel-section');
      carouselSection.style.setProperty('--js-top-offset', "".concat(headerHeight, "px"));
    }
    window.setInterval(() => {
      getHeight();
    }, 300);
  }
  swatches() {
    $('.product-swatch').click(function () {
      $(".product-swatch.is-active").removeClass("is-active");
      if (!$(this).hasClass('is-active')) {
        $(this).addClass("is-active");
      }
    });
  }
  quantitySelector() {
    var control = $('.product-quantity-button');
    control.click(event => {
      var {
        action
      } = event.target.dataset;
      var input = $('.product-quantity-number');
      var currentQty = parseInt(input.val(), 10);
      if (action === 'plus') {
        input.val(currentQty += 1);
      }
      if (action === 'minus' && currentQty > 1) {
        input.val(currentQty -= 1);
      }
    });
  }
  openTab(tab) {
    var $tabContent = $(tab).next();
    this.tabsElements.forEach(el => {
      if (tab === el) {
        return;
      }
      el.classList.remove('js-is-open');
      $(el).next().stop().slideUp();
    });
    if (tab.classList.contains('js-is-open')) {
      $tabContent.stop().slideUp();
      tab.classList.remove('js-is-open');
      return;
    }
    $tabContent.stop().slideDown();
    tab.classList.add('js-is-open');
  }
  preorderButton() {
    var checkLoaded = window.setInterval(() => {
      if (window.pn == null) {
        return;
      }
      if (window.pn.running == null) {
        return;
      }
      window.clearInterval(checkLoaded);
      document.querySelector('.product-submit-container').classList.remove('not-loaded');
    }, 100);
    var elemToObserve = document.querySelector('.product-submit');
    var prevClassState = elemToObserve.classList.contains('sbb');
    var observer = new MutationObserver(mutations => {
      // eslint-disable-next-line shopify/prefer-early-return
      mutations.forEach(mutation => {
        if (mutation.attributeName === "class") {
          var currentClassState = mutation.target.classList.contains('sbb');
          if (prevClassState !== currentClassState) {
            prevClassState = currentClassState;
            if (currentClassState) {
              document.querySelector('.product-submit-grid').classList.add('preorder-button-container');
              var preorderDescription = document.querySelector('.preorder-description');
              var preorderDescriptionHeightObserver = new ResizeObserver(thePreorderDescription => {
                document.documentElement.style.setProperty('--preorder-description-height', "".concat(thePreorderDescription[0].target.clientHeight, "px"));
              });
              preorderDescriptionHeightObserver.observe(preorderDescription);
            } else {
              window.console.log("");
            }
          }
        }
      });
    });
    observer.observe(elemToObserve, {
      attributes: true
    });
  }
  onMediaClick(mediaElement) {
    if (window.matchMedia("(max-width: ".concat(this.mediaMobileChange - 1, "px)")).matches) {
      return;
    }
    this.sliderModal.open(mediaElement);
  }
}
if (window.customElements.get('product-section') == null) {
  window.customElements.define('product-section', Product);
}

/***/ }),

/***/ "./zrc/scripts/templates/product-alternate/main/size-guide.js":
/*!********************************************************************!*\
  !*** ./zrc/scripts/templates/product-alternate/main/size-guide.js ***!
  \********************************************************************/
/***/ (() => {

class SizeGuide extends window.HTMLElement {
  connectedCallback() {
    this.container = this;
    this.classClosed = 'closed';
    this.triggerEl = this.querySelector('.size-guide-trigger');
    this.contentEl = this.querySelector('.size-guide-content');
    this.isClosed = true;
    this.attachListeners();
  }
  attachListeners() {
    this.triggerEl.addEventListener('click', this.open.bind(this));
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') {
        return;
      }
      this.close();
    });
    this.addEventListener('size-guide::open', () => {
      this.addEventListener('click', this.onDocumentClick.bind(this));
    });
  }
  onDocumentClick(event) {
    if (event.target !== this && this.contains(event.target)) {
      return;
    }
    if (event.target !== this && this.isClosed) {
      return;
    }
    this.close();
  }
  open() {
    this.dispatchEvent(new window.Event('size-guide::open'));
    this.classList.remove(this.classClosed);
    this.isClosed = false;
  }
  close() {
    this.classList.add(this.classClosed);
    this.isClosed = true;
    this.removeEventListener('click', this.onDocumentClick.bind(this));
  }
}
if (window.customElements.get('size-guide') == null) {
  window.customElements.define('size-guide', SizeGuide);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"product-alternate": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/product-alternate/main/product-main.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;